import styled from "styled-components";
import { Select } from "styles/elements";

export const FilterSelect = styled(Select)`
  width: 175px;
  padding: 5px 3px;
  font-size: 11.5pt;

  @media (max-width: 700px) {
    width: 110px;
    font-size: 11pt;
  }
`;
